import React from 'react'
import { Pane, majorScale } from '@segment/react-ui-library'

const Card = props => <Pane {...props} />

Card.defaultProps = {
  margin: majorScale(2),
  white: true,
  border: true,
  rounded: true,
  overflow: 'hidden'
}

export default Card



// WEBPACK FOOTER //
// ./components/Customers/presentational/Card.js